import React from 'react';

import SlaDiscrepanciesTable from '../components/sla-discrepancies/table';

class SlaDiscrepanciesPage extends React.Component {

    render() {
        return (
            <SlaDiscrepanciesTable />
        )
    }

}

export default SlaDiscrepanciesPage;


// WEBPACK FOOTER //
// ./src/containers/sla-discrepancies-page.js